import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/utils/utils";

interface Tab {
  name: string;
  value: string;
}

interface SheetTabsListProps {
  tabs: Tab[];
  disabled?: boolean;
}

export const SheetTabsList = ({ tabs, disabled }: SheetTabsListProps) => {
  return (
    <TabsList>
      {tabs.map((t, i) => (
        <TabsTrigger
          value={t.value}
          disabled={disabled}
          className={cn("text-sm", i === 0 && "ml-sheet-gap")}
          key={`tab-${i}`}
        >
          {t.name}
        </TabsTrigger>
      ))}
    </TabsList>
  );
};
